<flx-glow-line [color]="color"></flx-glow-line>
<div class="scrollable-area" [ngStyle]="{ height: height, padding: padding, maxheight: maxheight }"><ng-content></ng-content></div>
<flx-glow-line [color]="color"></flx-glow-line>
